import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Dropdown } from "react-bootstrap";

// css
import styles from "./Sidebar.module.scss";
import Checkbox from "../Checkbox";

// actions
import actions from "../../store/actions";

// helper
import { DISPLAY, DIRECTION, START_FROM } from "../../helpers/constants";

const Sidebar = () => {
  const dispatch = useDispatch();

  const { wheelSettings } = useSelector((state) => state.gannWheel);

  const handleWheelChange = (index, name) => (evt) => {
    dispatch(
      actions.updateByName({
        category: "wheelSettings",
        name: "wheels",
        value: [
          ...wheelSettings.wheels.slice(0, index),
          { ...wheelSettings.wheels[index], [name]: evt.target.value },
          ...wheelSettings.wheels.slice(index + 1),
        ],
      })
    );
  };

  const addNewWheel = () => {
    dispatch(
      actions.updateByName({
        category: "wheelSettings",
        name: "wheels",
        value: [...wheelSettings.wheels, {}],
      })
    );
  };

  const removeWheel = (idx) => () => {
    dispatch(
      actions.updateByName({
        category: "wheelSettings",
        name: "wheels",
        value: [
          ...wheelSettings.wheels.slice(0, idx),
          ...wheelSettings.wheels.slice(idx + 1),
        ],
      })
    );
  };

  return (
    <div className={`${styles.CstmDropdown} CstmDropdown h-100`}>
      <div className="top text-end">
        <Button
          className="d-inline-flex bg-transparent border-0 p-0"
          onClick={addNewWheel}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M15 7H9V1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0C7.73478 0 7.48043 0.105357 7.29289 0.292893C7.10536 0.48043 7 0.734784 7 1V7H1C0.734784 7 0.48043 7.10536 0.292893 7.29289C0.105357 7.48043 0 7.73478 0 8C0 8.26522 0.105357 8.51957 0.292893 8.70711C0.48043 8.89464 0.734784 9 1 9H7V15C7 15.2652 7.10536 15.5196 7.29289 15.7071C7.48043 15.8946 7.73478 16 8 16C8.26522 16 8.51957 15.8946 8.70711 15.7071C8.89464 15.5196 9 15.2652 9 15V9H15C15.2652 9 15.5196 8.89464 15.7071 8.70711C15.8946 8.51957 16 8.26522 16 8C16 7.73478 15.8946 7.48043 15.7071 7.29289C15.5196 7.10536 15.2652 7 15 7Z"
              fill="black"
            />
          </svg>
        </Button>
      </div>

      <div className="bottom h-100">
        <div className="table-responsive h-100">
          <table className="table">
            <thead>
              <tr>
                <th className="px-1 py-1 bg-transparent border-0 ws-nowrap"></th>
                <th className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                  Display
                </th>
                <th className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                  Direction
                </th>
                <th className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                  Start From
                </th>
              </tr>
            </thead>

            <tbody>
              {wheelSettings.wheels.map((wheel, idx) => (
                <tr key={`wheel-${idx}`}>
                  <td className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                    <div className="d-flex align-items-center bg-transparent justify-content-center gap-10">
                      <Button
                        className="border-0 p-0 bg-transparent"
                        variant="transparent"
                        onClick={removeWheel(idx)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="10"
                          viewBox="0 0 5 5"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_2_4)">
                            <path
                              d="M1.21322 0.756748L2.49989 2.04341L3.77989 0.763415C3.80817 0.733321 3.84222 0.709246 3.88003 0.692635C3.91783 0.676025 3.9586 0.667219 3.99989 0.666748C4.0883 0.666748 4.17308 0.701867 4.23559 0.764379C4.29811 0.826891 4.33322 0.911676 4.33322 1.00008C4.334 1.04095 4.32642 1.08154 4.31094 1.11938C4.29547 1.15721 4.27242 1.19148 4.24322 1.22008L2.94656 2.50008L4.24322 3.79675C4.29816 3.8505 4.33038 3.92328 4.33322 4.00008C4.33322 4.08849 4.29811 4.17327 4.23559 4.23578C4.17308 4.2983 4.0883 4.33341 3.99989 4.33341C3.95741 4.33518 3.91503 4.32809 3.87543 4.31259C3.83584 4.2971 3.7999 4.27354 3.76989 4.24341L2.49989 2.95675L1.21656 4.24008C1.18839 4.26917 1.15475 4.2924 1.11756 4.30842C1.08037 4.32444 1.04038 4.33293 0.999891 4.33341C0.911486 4.33341 0.826701 4.2983 0.764189 4.23578C0.701677 4.17327 0.666558 4.08849 0.666558 4.00008C0.665781 3.95921 0.673363 3.91862 0.68884 3.88079C0.704316 3.84296 0.727361 3.80869 0.756558 3.78008L2.05322 2.50008L0.756558 1.20341C0.70162 1.14967 0.669405 1.07689 0.666558 1.00008C0.666558 0.911676 0.701677 0.826891 0.764189 0.764379C0.826701 0.701867 0.911486 0.666748 0.999891 0.666748C1.07989 0.667748 1.15656 0.700081 1.21322 0.756748Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2_4">
                              <rect width="5" height="5" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </Button>

                      <Checkbox
                        checked={wheel.enabled}
                        onChange={handleWheelChange(idx, "enabled")}
                      />
                    </div>
                  </td>

                  <td className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                    <Dropdown
                      className={`${styles.dropdown} bg-transparent p-0`}
                    >
                      <Dropdown.Toggle
                        variant="transparent"
                        className="text-dark border fw-sbold text-capitalize"
                        id="dropdown-basic"
                      >
                        {DISPLAY[wheel.display] || ""}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          href="#/action-1"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "display"
                            )({ target: { value: "degrees" } })
                          }
                        >
                          {DISPLAY.degrees}
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#/action-2"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "display"
                            )({ target: { value: "day" } })
                          }
                        >
                          {DISPLAY.day}
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#/action-3"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "display"
                            )({ target: { value: "year" } })
                          }
                        >
                          {DISPLAY.year}
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#/action-4"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "display"
                            )({ target: { value: "planets" } })
                          }
                        >
                          {DISPLAY.planets}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>

                  <td className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                    <Dropdown
                      className={`${styles.dropdown} bg-transparent p-0`}
                    >
                      <Dropdown.Toggle
                        variant="transparent"
                        className="text-dark border fw-sbold"
                        id="dropdown-basic"
                      >
                        {DIRECTION[wheel.direction] || ""}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          href="#/action-1"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "direction"
                            )({ target: { value: "clockwise" } })
                          }
                        >
                          {DIRECTION.clockwise}
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#/action-2"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "direction"
                            )({ target: { value: "counter_clockwise" } })
                          }
                        >
                          {DIRECTION.counter_clockwise}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>

                  <td className="px-1 py-1 bg-transparent border-0 ws-nowrap">
                    <Dropdown
                      className={`${styles.dropdown} bg-transparent p-0`}
                    >
                      <Dropdown.Toggle
                        variant="transparent"
                        className="text-dark border fw-sbold"
                        id="dropdown-basic"
                      >
                        {START_FROM[wheel.startFrom] || ""}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          href="#/action-1"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "startFrom"
                            )({ target: { value: "east" } })
                          }
                        >
                          {START_FROM.east}
                        </Dropdown.Item>
                        {/* <Dropdown.Item
                          href="#/action-2"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "startFrom"
                            )({ target: { value: "west" } })
                          }
                        >
                          {START_FROM.west}
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#/action-3"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "startFrom"
                            )({ target: { value: "north" } })
                          }
                        >
                          {START_FROM.north}
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#/action-4"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "startFrom"
                            )({ target: { value: "south" } })
                          }
                        >
                          {START_FROM.south}
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#/action-5"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "startFrom"
                            )({ target: { value: "moveable" } })
                          }
                        >
                          {START_FROM.moveable}
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#/action-6"
                          onClick={() =>
                            handleWheelChange(
                              idx,
                              "startFrom"
                            )({ target: { value: "selection" } })
                          }
                        >
                          {START_FROM.selection}
                        </Dropdown.Item> */}
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
